/*! Wi-comments - v0.0.2
 * https://www.wicode.pl/
 */

var url_comments, url_comments_messages, url_comments_save, url_comments_delete;
var comments_scroll_l, comments_scroll_t;

+function ($) {
    'use strict';

    const wiComments = window.wiComments = {
        init() {
            this.events.init();
        },

        refresh() {
            wiPlugins.refresh();
        },

        events: {
            init() {
                // Edit comment
                $(document).off('click', '.comment-edit').on('click', '.comment-edit', function (e) {
                    e.preventDefault();

                    const comment_id = $(this).data('comment-id');
                    const parent_id = $(this).data('parent') ?? 0;

                    const $content = $(this).closest('.comments').find('.comment-content');
                    const content = $content.html() || '';

                    const $editorContainer = $('#comments-form');
                    const $form = $editorContainer.find('form');
                    const $summernote = $editorContainer.find('.summernote');

                    const $editingArea = $editorContainer.find('.note-editing-area');

                    wiComments.resetForm($form);

                    $('<div class="note-reply-block"></div>').html(`
                        <button type="button" class="note-reply-close" title="${lang.editor_cancel}">&times;</button>
                        <div class="note-reply-content">
                            <strong><i class="fa fa-edit fa-fw"></i> ${lang.editor_editing}:</strong>
                        </div>
                    `).insertBefore($editingArea.find('.note-editable'));

                    $form.find('input[name="comment_id"]').val(comment_id);
                    $form.find('input[name="parent_id"]').val(parent_id);
                    $form.find('input[name="action"]').val('edit');

                    $summernote.summernote('pasteHTML', content);
                    $summernote.summernote('focus');
                });

                // Reply to comment
                $(document).off('click', '.comment-reply').on('click', '.comment-reply', function (e) {
                    e.preventDefault();

                    const parent_id = $(this).data('parent');

                    const $editorContainer = $('#comments-form');
                    const $form = $editorContainer.find('form');
                    const $summernote = $editorContainer.find('.summernote');

                    const $content = $(this).closest('.comments').find('.comment-content');
                    const content = $content.html() || '';

                    wiComments.resetForm($form);

                    $form.find('input[name="parent_id"]').val(parent_id);
                    $form.find('input[name="comment_id"]').val(0);
                    $form.find('input[name="action"]').val('reply');

                    const $editingArea = $editorContainer.find('.note-editing-area');

                    $('<div class="note-reply-block"></div>').html(`
                        <button type="button" class="note-reply-close" title="${lang.editor_cancel}">&times;</button>
                        <div class="note-reply-content">
                            <strong>↪ ${lang.editor_reply_to}:</strong>
                            <div>${content}</div>
                        </div>
                    `).insertBefore($editingArea.find('.note-editable'));

                    $summernote.summernote('focus');
                });

                $(document).on('click', '.note-reply-close', function () {
                    const $form = $(this).closest('.comment-editor').find('form');
                    wiComments.resetForm($form);
                });

                // Confirm delete
                $(document).on('click', '.comment-confirm-delete', function (e) {
                    e.preventDefault();
                    const comment_id = $(this).data('comment-id');
                    wiVars.set.variables();
                    wiModal.get({
                        modal: 'comment_delete_confirmation',
                        module: 'comments',
                        url: 'comments',
                        comment_id,
                        referral_id: comment_referral_id,
                        referral_type: comment_referral_type,
                        subreferral_id: comment_subreferral_id,
                        subreferral_type: comment_subreferral_type,
                        target_referral_id: referral_id,
                        target_referral_type: referral_type,
                        target_subreferral_id: subreferral_id,
                        target_subreferral_type: subreferral_type
                    });
                });

                $(document).on('click', '#comment_delete_btn', function (e) {
                    e.preventDefault();
                    const form_data = $('#comment_delete_form').serialize();
                    $.post(url_comments_delete, form_data, function (jData) {
                        $('.wiComments').modal('hide');
                        wiAlerts.add(jData.status, jData.title, jData.msg);
                        wiComments.get.messages();
                    });
                });

                $(document).on('keydown', '.note-editable', function (e) {
                    if (e.key === 'Backspace') {
                        const $editable = $(this);
                        const sel = window.getSelection();

                        if (sel.rangeCount > 0) {
                            const range = sel.getRangeAt(0);
                            const container = range.startContainer;

                            const nodeBefore = container.nodeType === 3
                                    ? container.previousSibling
                                    : container.childNodes[range.startOffset - 1];

                            // Handle attached file removal
                            if (nodeBefore && nodeBefore.classList?.contains('attached-file')) {
                                e.preventDefault();
                                const $fileSpan = $(nodeBefore);
                                const $form = $fileSpan.closest('form');
                                wiPlugins.fileButton.removeAttachedFile($fileSpan, $form);
                                return;
                            }
                        }

                        // Handle empty editor (after backspace deletes everything)
                        // Wait 0ms so the DOM updates after keypress
                        setTimeout(() => {
                            const content = $(this).html().trim();
                            const isEmpty = !content || content === '<p><br></p>' || content === '<br>';

                            if (isEmpty) {
                                const $form = $(this).closest('.comment-editor').find('form');
                                wiComments.resetForm($form);
                            }
                        }, 0);
                    }
                });

                $(document).on('submit', '#comments-form', function (e) {
                    e.preventDefault();

                    const form = e.target;
                    if (!(form instanceof HTMLFormElement)) {
                        console.error('The event target is not a form element.');
                        return;
                    }

                    const $form = $(form);

                    const btn = form.querySelector('.note-btn-send');
                    if (!btn)
                        return;

                    const icon = btn.querySelector('.fa');
                    const originalIconClass = 'fa-paper-plane';

                    btn.disabled = true;
                    icon?.classList.remove(originalIconClass);
                    icon?.classList.add('fa-spinner', 'fa-spin');

                    const formData = new FormData(form);

                    const $editor = $form.find('.summernote');

                    let cleanedHTML = '';
                    if (!$editor.summernote('isEmpty')) {
                        cleanedHTML = $editor.summernote('code').trim();

                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = cleanedHTML;
                        tempDiv.querySelectorAll('.attached-file').forEach(el => el.remove());
                        tempDiv.querySelectorAll('.pasted-wrapper').forEach(wrapper => {
                            // Move children out of the wrapper
                            while (wrapper.firstChild) {
                                wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                            }
                            wrapper.remove();
                        });
    
                        cleanedHTML = tempDiv.innerHTML.trim();
                    }

                    formData.set('comment', cleanedHTML);

                    // Re-add files (if any)
                    formData.delete('userfiles[]');
                    const files = window.fileStore?.get(form) || [];
                    files.forEach(file => formData.append('userfiles[]', file));

                    fetch(url_comments_save, {
                        method: 'POST',
                        body: formData
                    })
                            .then(res => res.json())
                            .then(jData => {
                                btn.disabled = false;
                                icon?.classList.remove('fa-spinner', 'fa-spin');
                                icon?.classList.add(originalIconClass);

                                if (jData.status === 'success') {
                                    wiComments.resetForm($form);
                                    wiComments.get.messages();
                                    $('.wiComments').modal('hide');
                                }

                                if (typeof wiAlerts !== 'undefined') {
                                    wiAlerts.add(jData.status, jData.title, jData.msg);
                                }
                            })
                            .catch(error => {
                                console.error('Error:', error);
                                btn.disabled = false;
                                icon?.classList.remove('fa-spinner', 'fa-spin');
                                icon?.classList.add(originalIconClass);
                            });
                });

            },

            refresh() {
                $('#comments-messages-inner').on('scroll', function () {
                    comments_scroll_l = $(this).scrollLeft();
                    comments_scroll_t = $(this).scrollTop();
                });
            }
        },

        resetForm($form) {
            if (!$form) {
                return;
            }
            const $summernote = $form.find('.summernote');
            $summernote.summernote('code', '');

            $form.find('textarea[name="comment"]').val('');
            $form.find('input[name="comment_id"]').val(0);
            $form.find('input[name="parent_id"]').val(0);
            $form.find('input[name="action"]').val('create');

            $form.find('.attached-file').remove();
            $form.find('.comment_file').val('');
            $form.find('.attached-files-meta').val('[]');

            $form.find('.note-reply-block').remove();

            window.fileStore.set($form[0], []);
        },

        get: {
            comments() {
                $.get(url_comments, {
                    language_id,
                    referral_id: comment_referral_id,
                    referral_type: comment_referral_type,
                    subreferral_id: comment_subreferral_id,
                    subreferral_type: comment_subreferral_type,
                    target_referral_id: referral_id,
                    target_referral_type: referral_type,
                    target_subreferral_id: subreferral_id,
                    target_subreferral_type: subreferral_type,
                    csrf_wicode: csrf_value
                }, function (data) {
                    $('#comments_area').html(data.comments);
                    wiComments.refresh();
                    wiComments.get.messages();
                });
            },

            messages() {
                $.get(url_comments_messages, {
                    language_id,
                    referral_id: comment_referral_id,
                    referral_type: comment_referral_type,
                    subreferral_id: comment_subreferral_id,
                    subreferral_type: comment_subreferral_type,
                    target_referral_id: referral_id,
                    target_referral_type: referral_type,
                    target_subreferral_id: subreferral_id,
                    target_subreferral_type: subreferral_type,
                    csrf_wicode: csrf_value
                }, function (data) {
                    $('#comments-messages').html(data.messages);
                    wiComments.events.refresh();
                    if (typeof wiActivity !== 'undefined') {
                        wiActivity.get(referral_id, referral_type);
                    }
                });
            }
        }
    };

    // Init on DOM ready
    $(function () {
        url_comments = urls.comments + '/get_comments';
        url_comments_messages = urls.comments + '/get_comments_messages';
        url_comments_save = urls.comments + '/save';
        url_comments_delete = urls.comments + '/delete';

        wiComments.init();
    });
}(jQuery);
